module.exports = "<section class=\"retailer has-footer-bar\">\r\n  <div class=\"tabs content-view\">\r\n    <div class=\"tab-wrapper\">\r\n      <tab-header header-text=\"{{'User Activity' | translate}}\"\r\n                  is-active=\"true\"\r\n                  tabindex=\"-1\">\r\n      </tab-header>\r\n    </div>\r\n    <div class=\"tab-content\">\r\n      <user-activity-reports>\r\n      </user-activity-reports>\r\n    </div>\r\n  </div>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin-reports/components/admin-reports-page/admin-reports-page.html
// module id = 1440
// module chunks = 0